// pointsToSheetInContextSpace( ... )
// take points in one colorspace and plot them
// as a *textured sheet!*
// (my word for a four-cornered, possibly bent mesh with no sharp edges)
// in another colorspace

// takes points = an array of rows, each containing arrays representing points
// e.g.,[ [ [0,0,0], [1,1,1] ], [ [2,2,2], [3,3,3] ] ]
// (also takes a bunch of other inputs...)
// returns THREE.Mesh

import {
	CanvasTexture,
	DisplayP3ColorSpace,
	DoubleSide,
	MeshBasicMaterial,
	BufferGeometry,
	Float32BufferAttribute,
	BufferAttribute,
	Mesh
} from 'three';

import {
	to as convert
} from "../node_modules/colorjs.io/src/index-fn.js";
import reorderArray from './reorderArray.js';
import sheetIndices from './sheetIndices.js';
import unitSquareGridPoints from './unitSquareGridPoints.js';
import fourColorCanvas from './fourColorCanvas.js';


export default function pointsToSheetInContextSpace(
	pointsSpace, // ColorSpace
	contextSpace, // ColorSpace
	contextChannelsToXYZ_Map, // Array<3> e.g. [1,0,2] for L->y, a->x, b->z
	points, // Array<n> of Array<n>s of Array<3>s (see above)
	opacity, // Number, between 0-1
	doubleSided // Boolean
) {

	// First, we make a CanvasTexture...

	// Canvas..
	const lastColIndex = points[0].length - 1;
	const lastRowIndex = points.length - 1;
	const canvas = fourColorCanvas(
		// fourColors
		/* fourColorCanvas wants
		1---3
		|   |
		0---2 
		*/
		// TODO? I do not understand this order! Trial and error'd it.
		[

			points[lastRowIndex][0],
			points[0][0],
			points[lastRowIndex][lastColIndex],
			points[0][lastColIndex],

		],
		pointsSpace,
		[100,100] // dimensions
	);
	// document.body.appendChild(canvas);

	// ...Texture!
	const texture = new CanvasTexture(canvas);
	texture.colorSpace = DisplayP3ColorSpace;

	// Then, turn that Texture into a Material
	const materialOptions = { map: texture };
	if ( opacity < 1 ) {
		materialOptions.transparent = true;
		materialOptions.opacity = opacity;
	}
	if ( doubleSided ) {
		materialOptions.side = DoubleSide;
	}
	const material = new MeshBasicMaterial( materialOptions );

	// Now we need some gemoetry
	// Start by turning our input points into a flat array of vertices
	const vertices = points.flat().map( point => 
		reorderArray(
			convert( { space: pointsSpace, coords: point }, contextSpace ).coords,
			contextChannelsToXYZ_Map
		)
	);

	// Then connect the dots with sheetIndicies() to turn our vertecies into a sheet
	const vertexDensity = points[ 0 ].length
	const geometry = new BufferGeometry();
	geometry.setIndex( sheetIndices( vertexDensity ) );
	geometry.setAttribute( 'position', 
		new Float32BufferAttribute( vertices.flat(), 3 )
	);

	// Last, do some UV mapping
	// to distort the canvas to fit the (distorted, mapped to the contextSpace) points
	const uvs = unitSquareGridPoints( vertexDensity ).flat().flat();
	geometry.setAttribute( 'uv',
		new BufferAttribute( new Float32Array( uvs ), 2 )
	);

	// (do I actually need this??)
	geometry.computeVertexNormals();

	// Ta da! A Mesh!
	return new Mesh( geometry, material );

}
